/**
 * currentNumberOfDays actions
 */
import { SET_CURRENT_NUMBER_OF_DAYS } from './constants';

export function setCurrentNumberOfDays(numberOfDays: number) {
    return {
        type: SET_CURRENT_NUMBER_OF_DAYS,
        payload: {
            numberOfDays
        }
    };
}
